export function loggedUser() {
    let user = null;
    try {
        let data = JSON.parse(localStorage.getItem("user"));
        let hash = data.token.split('.');
        let buf = Buffer.from(hash[1], 'base64');
        user = JSON.parse(buf.toString());
    } catch (e) {
        console.warn('Could not get logged user.');
    }
    return user;
}